/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
//import router from '@/router/router'
import * as firebase from 'firebase';
import axios from 'axios';
import moment from 'moment'

Vue.use(Vuex);

// eslint-disable-next-line import/prefer-default-export
export const store = new Vuex.Store({

  // The default state and structure for a submission
  // We create the uid, created and updated props when writing to FB
  state: {
    people: '',
    loading: false,
    error: null,
    appointment: null,
    appointmentRescheduled: null,
    appointmentStatus: null, // pulled from submission uid > status
    offerExpiry: null,
    submission: {
      user: 0, // should be added via firebase node trigger 
      status: 1, // should be added via firebase node trigger
      reg: '',
      make: '', // copied at root level for search in dashboard (also in vehicle obj)
      model: '', // copied at root level for search in dashboard (also in vehicle obj)
      //vehicleId: null, //No longer use vehicleId with live API!
      vehicle: {},
      owners: null,
      condition: {
        mileage: null,
        mileageType: null,
        rating: null,
        description: null,
        serviceHistory: null,
        //repairCost: null,
        spareKey: null,
        spareTyre: null,
        tyresLegal: null,
        windscreenDamage: null,
        usedAsTaxi: null,
        financeOutstanding: null
      },
      images: [{ title: '', url: '' }],
      upload: '',
      //uploadLink: '',
      uploads: [],
      // customer fields also have to be at root level for search in dashboard
      firstName: '',
      surname: '',
      email: '',
      tel: '',
      //county: '',
      //postcode: ''
      ratingDescriptions: [
          '',
          'Major bodywork issues. Major previous accidental damage. Engine/gearbox issues. Will NOT pass an NCT. Mileage unconfirmed.',
          'Major bodywork issues / Many scratches. Previously damaged and repaired to an average standard. Possible engine/gearbox problems. Engine warning lights on. NCT Failed. Awaiting a retest. Mileage confirmed.',
          'Bodywork Has visible Scratch Marks 5/6 in total. Bumpers are also scratched. Structurally vehicle is in good shape (NOT Crashed Previously). No noticeable Engine or Gearbox Problems. NCT Passed if applicable. Some Service history available.',
          'Bodywork has 2/3 visible scratches. Bumpers with light scratches only. Engine and Gearbox Running well. NCT Passed if applicable. Service history available.',
          'NO Bodywork Issues. 1 Owner Car. Full service history. Manufacturers warranty still applies. NO Money to be spent! Very low mileage.'
      ]
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    submission (state) {
      return state.submission
    },
    appointment (state) {
      return state.appointment
    },
    appointmentStatus(state) {
      return state.appointmentStatus
    },
    offerExpiry(state) {
      return state.offerExpiry
    },
    regInvalid(state) {
      return state.regInvalid
    },
    people(state) {
      return state.people
    }
  },
  mutations: {
    // Submission state data
    vehicleFromApi (state, payload) { //vehicle info from API - ON REG SUBMIT
      state.submission.reg = payload.data.registration
      state.submission.make = payload.data.vehicle.nvdf.make
      state.submission.model = payload.data.vehicle.nvdf.model
      //state.submission.vehicleId = payload.data.vehicleId  No longer used
      state.submission.owners = payload.data.keepers.numberOfPrevious
      state.submission.vehicle = payload.data.vehicle.nvdf
    },

    customiseVehicle (state, payload) { //info from customer if NOT my car  STEP 1
      state.submission.make = payload.make
      state.submission.model = payload.model
      state.submission.vehicle.description = payload.description
      state.submission.vehicle.fuel = payload.fuel
      state.submission.vehicle.transmission = payload.transmission
      state.submission.vehicle.colour = payload.colour
    },

    customerImageUploads (state, payload) { //Image uploads STEP 2
      if(state.submission.uploads.length<5) {
        state.submission.uploads.push(payload)
      }
    },
    revokeCustomerImageUpload (state, payload) {
      //find the saved image by title and remove
      state.submission.uploads.forEach(function(item, index) {
        if(item.title==payload){
          state.submission.uploads.splice(index, 1) 
        }
      })
    },
    vehicleCondition (state, payload) { //Further details about vehicle STEP 3
      state.submission.condition = payload
    },

    customerDetails (state, payload) { //Final customer info gathered STEP 4
      state.submission.firstName = payload.firstName
      state.submission.surname = payload.surname
      state.submission.email = payload.email
      state.submission.tel = payload.tel
    },

    // Utils
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },

    //Firebase
    createNewSubmissionInFirebase (state) {
      let ts = firebase.database.ServerValue.TIMESTAMP;
      let newPostKey = firebase.database().ref('submissions').push().key;
      state.submission.uid = newPostKey
      state.submission.created = ts
      state.submission.updated = ts
      state.submission.status = 1
    },
    updateSubmissionInFirebase (state) {
      let updates = {};
      updates['/submissions/' + state.submission.uid] = state.submission
      firebase.database().ref().update(updates)
    },
    sendEmailAndSmsConfirmation (state) {
      axios.get('https://webeatweb.com/m4capi/sg-send-templated.php?origin=m4cForm&fname=' + state.submission.firstName 
      + '&surname=' + state.submission.surname 
      + '&email=' + state.submission.email 
      + '&tel=' + state.submission.tel
      + '&reg=' + state.submission.reg
      + '&make=' + state.submission.make
      + '&model=' + state.submission.model 
      + '&stage=submission&templateid=d-ef4f339fce604b789debe039dc869c13')
      .then((resp) => { 
        console.log(resp)
      })
      .catch((error) => { 
        console.log('Sending the success email to the customer failed: ',error) 
      })

    },
    sendEmailAppointmentConfirmation (state) {
      let niceDate = moment(state.appointment.date).format('DD/MM/YYYY')
      let appointDay = moment(state.appointment.date).format('dddd')
      axios.get('https://webeatweb.com/m4capi/sg-send-templated.php?origin=m4cForm&fname=' + state.submission.firstName 
      + '&surname=' + state.submission.surname 
      + '&email=' + state.submission.email
      + '&tel=' + state.submission.tel
      + '&reg=' + state.submission.reg
      + '&make=' + state.submission.make
      + '&model=' + state.submission.model 
      + '&appointday=' + appointDay
      + '&appointdate=' + niceDate
      + '&appointtime=' + state.appointment.time
      + '&appointurl=http://m4c.webeatweb.com/?appointment=' + state.appointment.uid
      + '&stage=appointment&templateid=d-cc6543345e4f4a57b3cfc7d9f2d96e5d')
      .then((resp) => { 
        console.log(resp)
      })
      .catch((error) => { 
        console.log('Sending the Appointment confirmation email to the customer failed: ',error) 
      })
    },
    


    setAppointment (state, payload) {
        state.appointment = payload
    },
    setAppointmentDate (state, payload) {
      state.appointment.date = payload
    },
    setAppointmentTime (state, payload) {
      state.appointment.time = payload
    },
    setAppointmentStatus (state, payload) {
      state.appointmentStatus = payload
    },
    setAppointmentExpiry (state, payload) {
      state.offerExpiry = payload
    },
    setRescheduleAppointment (state) {
      state.appointmentRescheduled = 1
    },
    updateAppointmentInFirebase (state) {
      let ts = firebase.database.ServerValue.TIMESTAMP;
      state.appointment.updated = ts
      if(state.appointmentRescheduled)
        state.appointment.rescheduled = 1

      let updates = {};
      updates['/appointments/' + state.appointment.uid] = state.appointment
      firebase.database().ref().update(updates)
    },
    updateSubmissionStatusViaAppointment(state, payload) {
      firebase.database().ref().child('/submissions/' + state.appointment.uid + '/status' ).set(payload)
    },
    setSubmission(state, payload) {
      state.submission = payload
    },
    setPeople(state, payload) {
      state.people = payload
    },
    updatePeople(state, payload) {
      firebase.database().ref('/people/').set(payload)
      state.people = payload
    }
    /* OLD
    setSubmissionFB (state) {
      let ts = firebase.database.ServerValue.TIMESTAMP;
      let newPostKey = firebase.database().ref('submissions').push().key;
      state.submission.uid = newPostKey
      state.submission.created = ts
      state.submission.updated = ts
    },
    updateStatus(state) {
      state.submission.status = 1 // should be done with FB trigger on backend
    },
    updateFirebaseSubmission (state) {
      let updates = {};
      updates['/submissions/' + state.submission.uid] = state.submission
      firebase.database().ref().update(updates)
      //let fbRef = firebase.database().ref('submissions/' + state.submission.uid);
      //fbRef.set(state.submission);
    },
    setSubmissionVehicleData (state, payload) {
      state.submission.reg = payload.data.registration
      state.submission.make = payload.data.vehicle.nvdf.make
      state.submission.model = payload.data.vehicle.nvdf.model
      state.submission.vehicleId = payload.data.vehicleId
      state.submission.owners = payload.data.keepers.numberOfPrevious
      state.submission.vehicle = payload.data.vehicle.nvdf
    },
    setSubmissionImages (state, payload) {
      state.submission.images = payload.data.images
      console.log(state.submission)
    },
    setSubmissionCondition (state, payload) {
      state.submission.condition = payload
    },
    setSubmissionUpload (state, payload) {
      state.submission.upload = payload //filename of file in bucket
    },
    setSubmissionUploadLink (state, payload) {
      state.submission.uploads.push(payload)
      //state.submission.uploadLink = payload //public link to download image in bucket
    },
    setsubmissionCustomer (state, payload) {
      state.submission.firstName = payload.firstName
      state.submission.surname = payload.surname
      state.submission.email = payload.email
      state.submission.tel = payload.tel
      //state.submission.county = payload.county
      //state.submission.postcode = payload.postcode
      
    },*/
    

  },
  actions: {
    anonLogin() {
      firebase.auth().signInAnonymously();
    },
    anonLogout() {
      firebase.auth().signOut();
    },
    fetchPeople({commit}) {
      return new Promise(function(resolve, reject) {
        firebase.database().ref('/people/').on('value', snapshot => {
          let gotPeople = snapshot.val()
          commit('setPeople', gotPeople)
          resolve()
        })
      })
    },
    updatePeople({commit}, payload) {
      commit('updatePeople', payload)
    },
    cancelAppointment({commit}) {
      commit('updateSubmissionStatusViaAppointment', 5) // 5 = cancelled
      // no need to update appointment, submission status is king
    },
    rescheduleAppointment({commit}) {
      commit('setRescheduleAppointment')
      commit('updateAppointmentInFirebase')
      commit('updateSubmissionStatusViaAppointment', 2) //  = booked
      commit('sendEmailAppointmentConfirmation')
    },
    bookAppointment({commit}) {
      commit('updateAppointmentInFirebase')
      commit('updateSubmissionStatusViaAppointment', 2) //  = booked
      commit('sendEmailAppointmentConfirmation')
    },
    fetchAppointment({commit, dispatch}, payload) { // payload - uid
      return new Promise(function(resolve, reject) {
        
        firebase.database().ref('appointments/' + payload).on('value', snapshot => {
          let gotAppointment = snapshot.val()
          //console.log(gotAppointment)
          let freshAppointment = {
            uid: payload,
            date: null,
            time: null
          }
          if(gotAppointment==null)
            gotAppointment = freshAppointment
          commit('setAppointment', gotAppointment)
          dispatch('fetchAppointmentStatus', payload)
          dispatch('fetchExpiry', payload)
          resolve()
        })

      })
    },
    fetchAppointmentStatus({commit}, payload) { //payload = uid
      return new Promise(function(resolve, reject) {
        // Get status from submission:
        firebase.database().ref('submissions/' + payload + '/status').once('value', snapshot => {
          
          commit('setAppointmentStatus', snapshot.val())
          //Boost if the appointment is no longer open
          //if(snapshot.val() !==2 || snapshot.val()!==4) {
            //console.log('push!')
            //router.push('/')
          //}
          resolve()
        })
      })
    },
    fetchExpiry({commit}, payload) { //payload = uid
      return new Promise(function(resolve, reject) {
        // Get status from submission:
        firebase.database().ref('offers/' + payload).once('value', snapshot => {
          
          let offers = snapshot.val()
          
          if(offers) {
            let expiryDate = ''
            for (const key in offers) {
              if (offers.hasOwnProperty(key)) {
                const element = offers[key];
                expiryDate = element.expires
              }
            }
            let expiryBits = expiryDate.split('/')
            let expiry = expiryBits[2]+'-'+expiryBits[1]+'-'+expiryBits[0]
            //console.log(expiry)
            commit('setAppointmentExpiry', expiry)
          }
          resolve()
        })
      })
    },
    fetchSubmission ({commit}, payload) {
      return new Promise(function(resolve, reject) {
        // Get status from submission:
        firebase.database().ref('submissions/' + payload).once('value', snapshot => {
          commit('setSubmission', snapshot.val())
          resolve()
        })
      })
    },
    setAppointmentDate ({commit}, payload) {
      commit('setAppointmentDate', payload)
    },
    setAppointmentTime ({commit}, payload) {
      commit('setAppointmentTime', payload)
    },
    storeVehicleFromApi({commit}, payload) { //REG Lookup > Vehicle data
      commit('vehicleFromApi', payload)
    },
    storeCustomiseVehicle ({commit}, payload) { //STEP 1
      commit('customiseVehicle', payload)
    },
    storeCustomerImageUploads ({commit}, payload) { //STEP 2
      commit('customerImageUploads', payload)
    }, 
    revokeCustomerImageUpload({commit}, payload) {
      commit('revokeCustomerImageUpload', payload)
    },
    storeVehicleCondition ({commit}, payload) { //STEP 3
      commit('vehicleCondition', payload)
    },
    storeCustomerDetails({commit}, payload) { //STEP 4
      commit('customerDetails', payload)
      
      //Now save the whole submission to FB
      //Should trigger node @ firebase for sendgrid & twilio functions replacing sendEmailAndSmsConfirmation

      //console.log(this.state.submission)
      commit('createNewSubmissionInFirebase')
      commit('updateSubmissionInFirebase')
      commit('sendEmailAndSmsConfirmation')
    },

    //We using these?
    clearError({commit}) {
      commit('clearError')
    },

  },
})